/**
 * We add jitter to the array by shuffling it in order to prevent/reduce starvation of records 
 * that normally would appear at the end of the array if we iterated in a deterministic order
 *
 * We use the Knuth-Fisher-Yates shuffle algorithm from https://blog.codinghorror.com/the-danger-of-naivete/
 */
export function shuffle<T>(array: T[]): T[] {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}
